import React from "react";

import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import MapIcon from "@mui/icons-material/Map";
import CalendarIcon from "@mui/icons-material/CalendarToday";
import CalendarIconMonth from "@mui/icons-material/CalendarMonth";
import EmailIcon from "@mui/icons-material/Email";
import {
  Admin,
  Resource,
  fetchUtils,
  defaultTheme,
  combineDataProviders,
} from "react-admin";
import simpleRestProvider from "./providers/simpleRestProvider";

import Dashboard from "./components/dashboard/Dashboard";
import authProvider from "./providers/authProvider";
import { UserEdit, UserList, UserCreate } from "./components/users";
import {
  ProviderCreate,
  ProviderEdit,
  ProviderList,
  ProviderShow,
} from "./components/providers";
import MailhogViewer from "./components/email/MailhogViewer";

import { extractResourceParams } from "./services/gennev-api.service";
import { UserDataProvider } from "./providers/userDataProvider";
import { AppointmentList } from "./components/appointments/AppointmentList";
import { AcuityAppointmentList } from "./components/appointments/AcuityAppointmentList";
import { AthenaAppointmentList } from "./components/appointments/AthenaAppointmentList";

const { REACT_APP_GENNEV_API_URL } = process.env;

const httpClient = (url, options = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: "application/json" });
  }

  const token = localStorage.getItem("token");
  options.headers.set("Authorization", `Bearer ${token}`);
  return fetchUtils.fetchJson(url, options);
};
const commonTheme = {
  defaultTheme,
  components: {
    ...defaultTheme.components,
  },
};

const lightTheme = commonTheme;
const darkTheme = {
  ...commonTheme,
  palette: {
    mode: "dark",
  },
};

const dataProvider = combineDataProviders((resource) => {
  const { normalizedResource, urlParams } = extractResourceParams(resource);

  switch (normalizedResource) {
    case "admin/user":
      return UserDataProvider();
    case "admin/roles":
    case "admin/providers":
    case "admin/medical/tablespaces":
    case "admin/medical/appointments":
    case "admin/medical/appointment-types":
    case "admin/medical/acuity/appointments":
    case "admin/medical/athena/appointments":
    case "geo/states":
      return simpleRestProvider(REACT_APP_GENNEV_API_URL, httpClient);
    default:
      // matching URLs with params
      console.log("resource provider not found", resource);
      return simpleRestProvider(REACT_APP_GENNEV_API_URL, httpClient);
  }
});

// function UserTaskList() {
//     return null;
// }

const App = () => (
  <Admin
    dataProvider={dataProvider}
    authProvider={authProvider}
    dashboard={Dashboard}
    theme={lightTheme}
    darkTheme={darkTheme}
    requireAuth
  >
    <Resource
      name="admin/user"
      options={{ label: "Users" }}
      icon={PeopleAltIcon}
      list={UserList}
      edit={UserEdit}
      create={UserCreate}
      recordRepresentation={(record) =>
        `${record.first_name} ${record.last_name}`
      }
    />

    <Resource
      name="admin/providers"
      options={{ label: "Providers" }}
      icon={LocalHospitalIcon}
      list={ProviderList}
      create={ProviderCreate}
      edit={ProviderEdit}
      show={ProviderShow}
      recordRepresentation={(record) =>
        `${record.user.first_name} ${record.user.last_name}`
      }
    />
    <Resource
      name="admin/medical/appointments"
      options={{ label: "Appointments" }}
      icon={CalendarIcon}
      list={AppointmentList}
    />
    <Resource
      name="admin/medical/acuity/appointments"
      options={{ label: "Acuity Appointments" }}
      icon={CalendarIconMonth}
      list={AcuityAppointmentList}
    />
    <Resource
      name="admin/medical/athena/appointments"
      options={{ label: "Athena Appointments" }}
      icon={CalendarIconMonth}
      list={AthenaAppointmentList}
    />
    <Resource
      name="admin/medical/tablespaces"
      options={{ label: "Tablespaces" }}
      recordRepresentation={(record) => `${record.name}`}
      icon={MapIcon}
    />
    <Resource
      name="admin/medical/appointment-types"
      options={{ label: "Appointment Types" }}
      recordRepresentation={(record) => `${record.description}`}
    />
    <Resource name="geo/states" options={{ label: "States" }} icon={MapIcon} />

    <Resource
      name="email-testing"
      options={{ label: "Email Testing" }}
      icon={EmailIcon}
      list={MailhogViewer}
    />
  </Admin>
);
export default App;
